import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiPost } from "../../../api";
import "../../../App.css";
import "../styles/ResendVerification.css";

import studentResend from "../../../images/student-resend-verification.png";

export default function ResendVerification() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const onResend = async (e) => {
    e.preventDefault();
    setMsg("");
    setIsSuccess(false);
    setLoading(true);
    try {
      const res = await apiPost("/auth/resend-verification", { email });
      setMsg(res.message || "Verification email sent (if account exists).");
      setIsSuccess(true);
    } catch (err) {
      setMsg(err.message || "Error sending verification email");
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="resend-page">
      <img
        src={studentResend}
        alt="Resend illustration"
        className="resend-illustration"
      />
      <div className="resend-box">
        <h1 className="resend-title">Resend</h1>

        <form onSubmit={onResend} className="resend-form">
          <label>Email used to register</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="yourname@my.yorku.ca"
          />
          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Send Verification"}
          </button>
        </form>

        {msg && <p className={`msg ${isSuccess ? "success" : "error"}`}>{msg}</p>}

        <div className="resend-links">
          <p>
            <Link to="/auth/react/signin" className="link">
              Sign In
            </Link>{" "}
            |{" "}
            <Link to="/auth/react/register" className="link">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}